import { X, Download } from "lucide-react";

interface DownloadModalProps {
  open: boolean;
  onClose: () => void;
  svgContent: string;
  downloadUrl: string;
}

export function DownloadModal({ open, onClose, svgContent, downloadUrl }: DownloadModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" onClick={onClose}>
      <div
        className="glass w-full max-w-3xl rounded-2xl overflow-hidden border border-white/10 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
          <p className="text-sm font-medium text-foreground/90">Your SVG is ready</p>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center w-8 h-8 rounded-md hover:bg-white/10 transition-colors"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="p-4 space-y-4">
          <div className="aspect-square rounded-xl bg-background/50 border border-white/10 overflow-hidden">
            <div
              className="w-full h-full flex items-center justify-center p-4"
              dangerouslySetInnerHTML={{ __html: svgContent }}
            />
          </div>

          <a
            href={downloadUrl}
            className="w-full inline-flex items-center justify-center gap-2 rounded-xl px-5 py-3 text-base font-semibold bg-primary text-primary-foreground glow-primary hover:opacity-90 transition-opacity"
          >
            <Download className="w-5 h-5" />
            Download SVG
          </a>
        </div>
      </div>
    </div>
  );
}
